import { SlackChannelInput, UpdateIntegrationData } from 'generated/graphql';
import { IntegrationChannelType } from 'generated/graphql';

export const getUpdateSlackAndEmailIntegrationInput = (
  channelType: IntegrationChannelType,
  slackChannels: SlackChannelInput[],
  emails: string[],
): Pick<UpdateIntegrationData, 'slack' | 'email'> => {
  if (channelType === IntegrationChannelType.Slack) {
    return {
      slack: {
        subscribedChannels: slackChannels,
      },
    };
  }
  if (channelType === IntegrationChannelType.Email) {
    return {
      email: {
        emails,
      },
    };
  }
  return {};
};
